import { gql } from '@apollo/client';

/**
 * Shared selection set for the `Breakdown` type.
 *
 * `createBreakdown` (mutation) and `workAssignmentSearchV2` (query) both
 * return `Breakdown` — pulling the same fields via one fragment keeps the
 * client-side shape identical, so a fresh breakdown returned from the
 * mutation can be spliced into an existing assignment in the store
 * without a follow-up refetch.
 */
export const BREAKDOWN_FIELDS = gql`
	fragment BreakdownFields on Breakdown {
		workAssignmentSequenceGroupId
		incidentTimestamp
		reason
		station {
			id
			code
			name
		}
		note
		deadhead {
			id
			busId
			rideNumber
			type
			crewMember {
				id
				fullName
				driverCard
			}
			departure {
				stationDetails {
					name
					code
				}
			}
			arrival {
				stationDetails {
					name
					code
				}
			}
		}
		inboundTravelingWorkAssignment {
			id
			crewMember {
				id
				fullName
				driverCard
			}
			fromStation {
				name
				code
			}
			toStation {
				name
				code
			}
			fromTimestamp
			toTimestamp
		}
		replacementCrewMember {
			id
			fullName
			driverCard
		}
		parallelRide {
			id
			tripNumber
			lineCode
			departure
			stations {
				id
				name
				code
			}
		}
		postIncidentDrivingAssignments {
			sequenceGroupId
			crewMember {
				id
				fullName
				driverCard
			}
			workAssignmentSequences {
				fromStation {
					code
					name
				}
				toStation {
					code
					name
				}
				fromTimestamp
				toTimestamp
			}
		}
		outboundTravelingWorkAssignment {
			id
			crewMember {
				id
				fullName
				driverCard
			}
			fromStation {
				name
				code
			}
			toStation {
				name
				code
			}
			fromTimestamp
			toTimestamp
		}
		absence {
			id
			fromTimestamp
			reason {
				id
				name
			}
		}
		createdAt
		updatedAt
		updatedBy
	}
`;
